import type { ListModule } from './constants';

export type CaptureTone = 'purple' | 'green' | 'blue';

export interface CapturePresentation {
  module: Extract<ListModule, 'places' | 'phones' | 'emails'>;
  icon: 'storefront' | 'call' | 'mail';
  tone: CaptureTone;
}

export const PRIMARY_CAPTURE_PRESENTATIONS: readonly CapturePresentation[] = [
  { module: 'places', icon: 'storefront', tone: 'purple' },
  { module: 'phones', icon: 'call', tone: 'green' },
  { module: 'emails', icon: 'mail', tone: 'blue' },
];

export const CAPTURE_PRESENTATION_BY_MODULE = Object.fromEntries(
  PRIMARY_CAPTURE_PRESENTATIONS.map((item) => [item.module, item]),
) as Partial<Record<ListModule, CapturePresentation>>;
